/**
 * Legacy colour constants for the RM task screens, now pointing at Artium
 * Design System tokens. Prefer ds classes and src/ui / ./ui-pending components;
 * these stay only for values that have to be passed as data (chart series).
 */
export const ACCENT = 'var(--ds-primary)';
export const ACCENT_SOFT = 'var(--ds-primary-soft)';
export const ACCENT_BORDER = 'color-mix(in srgb, var(--ds-primary) 35%, var(--ds-surface))';

/** Outcome tones for closed tickets and closing-reason buttons. */
export const TONE = {
  success: { fg: 'var(--ds-success)', bg: 'var(--ds-success-soft)', border: 'color-mix(in srgb, var(--ds-success) 35%, var(--ds-surface))' },
  fail: { fg: 'var(--ds-danger)', bg: 'var(--ds-danger-soft)', border: 'color-mix(in srgb, var(--ds-danger) 35%, var(--ds-surface))' },
  neutral: { fg: 'var(--ds-text-muted)', bg: 'var(--ds-surface-muted)', border: 'var(--ds-border-strong)' },
} as const;
